<template>
  <div>
    <!-- 기본정보 -->
    <field-select-module v-model="form.stdInfo" :board="this.board" :is-print="isPrint" />

    <!--관리자 그룹-->
    <table-inspection-group
      v-if="this.form.group1.length > 0"
      class="mt-5"
      title="점검 담당자 그룹"
      :list="form.group1"
      @updateList="updateGroupList"
      :isPrint="isPrint"
      :isReadonly="board.readonly"
    />

    <!--점검정보-->
    <vs-row class="mt-6">
      <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">
        <h5><i class="dot" /> 점검정보</h5>
      </vs-col>
    </vs-row>
    <div class="writeGridContainer mt-4">
      <div>
        <div>점검일</div>
        <span v-if="isPrint" class="print-input"> {{ form.inputA_1 }} </span>
        <date-selector v-else v-model="form.inputA_1" :readonly="board.readonly" />
      </div>
      <div>
        <div>점검장소</div>
        <p v-if="isPrint" class="print-input">{{ form.inputA_2 }}</p>
        <ml-input v-else v-model="form.inputA_2" :readonly="board.readonly" />
      </div>
      <div>
        <div>면적</div>
        <p v-if="isPrint" class="print-input">{{ form.inputA_4 }}</p>
        <comma-input v-else v-model="form.inputA_4" type="number" :readonly="board.readonly" />
        <p class="pl-2">m<sup>2</sup></p>
      </div>
      <div>
        <div>층수 (지하/지상)</div>
        <p v-if="isPrint" class="print-input">{{ form.inputA_5 }} / {{ form.inputA_6 }}</p>
        <div v-else class="flex items-center gap-3">
          <ml-input v-model="form.inputA_5" :readonly="board.readonly" />
          <span>/</span>
          <ml-input v-model="form.inputA_6" :readonly="board.readonly" />
        </div>
      </div>
      <div>
        <div>점검대상 건물용도</div>
        <p v-if="isPrint" class="print-input">{{ form.inputA_7 }}</p>
        <ml-input v-else v-model="form.inputA_7" :readonly="board.readonly" />
      </div>

      <div>
        <div>점검자</div>
        <p v-if="isPrint" class="print-input">소속 : {{ form.inputA_8 }} / 성명 : {{ form.inputA_9 }}</p>
        <div v-else class="flex items-center gap-4">
          <span>소속</span>
          <ml-input v-model="form.inputA_8" class="w-full flex-1" :readonly="board.readonly" />
          <span>성명</span>
          <ml-input v-model="form.inputA_9" class="w-full flex-1" :readonly="board.readonly" />
        </div>
      </div>
      <div>
        <div>점검여부</div>
        <p v-if="isPrint" class="print-input">{{ form.inputA_10 }}</p>
        <label v-else class="flex items-center"> <vs-checkbox v-model="form.inputA_10" vs-value="이행" :readonly="board.readonly" /> 이행 </label>
      </div>
    </div>

    <!--    점검대상-->
    <vs-row class="mt-6">
      <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">
        <h5><i class="dot" /> 점검대상</h5>
      </vs-col>
    </vs-row>
    <div class="grid xl:grid-cols-12 gap-x-6 gap-y-4 mt-4">
      <div class="col-span-2 flex items-center" v-for="checkbox in form.inspectList" v-bind:key="checkbox.id">
        <div v-if="isPrint || board.readonly" class="flex">
          <div v-if="checkbox.check" style="background: #200c63" class="w-5 h-5 rounded-sm text-white flex justify-center items-center mr-2">
            <vs-icon icon="check" size="x-small"></vs-icon>
          </div>
          <div v-else style="border: 1px solid #200c63" class="w-5 h-5 rounded-sm text-white flex justify-center items-center mr-2">
            <vs-icon icon="check" size="x-small"></vs-icon>
          </div>
          {{ checkbox.label }}
        </div>
        <label v-else class="flex">
          <vs-checkbox :readonly="board.readonly" v-model="checkbox.check" @change="checkForm"> </vs-checkbox>
          {{ checkbox.label }}
        </label>
      </div>
    </div>

    <!--    표-->
    <div v-for="(inspection, indexRows) in form.inspectList" v-bind:key="inspection.id">
      <table-inspect
        class="mt-8"
        v-bind:key="inspection.id"
        :is-print="isPrint"
        :is-readonly="board.readonly"
        :is-show-title="true"
        :title="inspection.title"
        :list="inspection.list"
        :isNotDotInLabel="false"
        :is-note="true"
        :is-bottom-note="true"
        table-header-title="점검사항"
        header-width-yes="80px"
        table-header-yes="양호"
        table-header-no="미흡"
        header-width-no="80px"
        table-header-na="해당없음"
        header-width-na="80px"
        table-header-note="비고(보완계획)"
        bottom-note-title="기타 점검의견"
        :init-bottom-note="inspection.note"
        @update-list-check="
          (param1, param2) => {
            updateListCheck(indexRows, param1, param2);
          }
        "
        @update-bottom-note="
          (text) => {
            updateBottomNote(indexRows, text);
          }
        "
        v-if="inspection.check"
      />
    </div>

    <!-- 파일첨부 -->
    <file-upload-module id="fileList" class="w-full mt-8" v-model="form.fileList" :is-print="isPrint" :readonly="board.readonly"></file-upload-module>

    <!-- 안전점검 계획 선택 팝업 -->
    <popup-safety-inspection-plan :popupActive="popupActive" @popupActiveSync="popupActiveSync" @handleItemClickDetail="handleItemClickDetail"/>
  </div>
</template>

<script>
import FileUploadModule from "@/views/modules/FileUploadModule";
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import PhotoUploadGridModule from "@/views/modules/PhotoUploadGridModule";
import FileUploader from "@/components/FileUploader";
import TableInspectEp from "@/components/TableInspectCustomEp";
import TableEtcCheck from "@/components/TableEtcCheck";
import CustomOptionSelector from "@/components/selector/CustomOptionSelector.vue";
import DateSelector from "@/components/selector/DateSelector.vue";
import TimeSelector from "@/components/selector/TimeSelector.vue";
import DisasterClassSelector from "@/components/selector/DisasterClassSelector.vue";
import TableInspect from "@/components/TableInspect";
import PopupSafetyInspectionPlan from '@/views/project/popup/PopupSafetyInspectionPlan'
import inspectTable from './inspectTable'
import TableInspectionGroup from '@/components/TableInspectionGroup'

export default {
  components: {
    TableInspectionGroup,
    PopupSafetyInspectionPlan,
    TableInspect,
    DisasterClassSelector,
    TimeSelector,
    DateSelector,
    CustomOptionSelector,
    TableEtcCheck,
    TableInspectEp,
    FileUploader,
    PhotoUploadGridModule,
    FieldSelectModule,
    FileUploadModule,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }

        if (!this.form || !this.form.inspectList || this.form.inspectList.length === 0) {
          this.form.inspectList = inspectTable;
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        value.title = this.board.writer.department;

        value.summary = {
          시설물점검_게시글: [{ "직영시설물 안전점검 이행": 1 }],
          시설물점검_사업장명: [],
          시설물점검_사업장주소: [],
          시설물점검_사업장구분: [],
          시설물점검_점검결과: [],
        };
        let checkCount = 0;
        for (const inspect of this.form.inspectList) {
          if (inspect.check) {
            checkCount++;
            value.summary["시설물점검_점검결과"].push({
              [inspect.title]: 1,
            });
          }
        }

        if (this.form.stdInfo.field_name) {
          value.summary["시설물점검_사업장명"].push({
            [this.form.stdInfo.field_name]: checkCount,
          });
        }
        if (this.form.stdInfo.field_address) {
          value.summary["시설물점검_사업장주소"].push({
            [this.form.stdInfo.field_address]: checkCount,
          });
        }
        if (this.form.stdInfo.facility_category && this.form.stdInfo.facility_category.cat1) {
          value.summary["시설물점검_사업장구분"].push({
            [this.form.stdInfo.facility_category.cat1]: checkCount,
          });
        }
        this.$emit("input", value);
      },
    },
  },
  data() {
    return {
      popupActive: false,
      form: {
        stdInfo: {},
        inputA_1: "",
        inputA_2: "",
        inputA_3: [],
        inputA_4: "",
        inputA_5: "",
        inputA_6: "",
        inputA_7: "",
        inputA_8: "",
        inputA_9: "",
        inputA_10: "",

        inputC_1: {},
        inputC_2: "",

        typeTitleList: [],
        inspectList: [],
        photoList: [],
        fileList: [],
        etcList: [],
        group1: [],
      },
    };
  },
  methods: {
    checkForm() {
      this.form.typeTitleList = [];
      for (const data of this.form.inspectList) {
        if (data.check) {
          this.form.typeTitleList.push(data.label);
        }
      }
    },
    updateGroupList (list) {
      this.form.group1 = list
    },
    updateListCheck(indexList, indexTableRows, text) {
      this.form.inspectList[indexList].list[indexTableRows].is_checked = text;
    },
    updateBottomNote(indexList, text) {
      this.form.inspectList[indexList].note = text;
    },

    updateEtcListCheck(row, text) {
      this.form.etcList[row].checked = text;
    },
    updateListNote(row, text) {
      this.form.etcList[row].note = text;
    },
    updateList(list) {
      this.form.etcList = list;
    },
    onClickCustomButton (button, buttonIndex) {
      this.popupActive = true;
    },
    popupActiveSync () {
      this.popupActive = false
    },
    handleItemClickDetail (data) {
      if (data.post_content) {
        this.popupActive = false
        const content = JSON.parse(data.post_content)
        const group1 = content.body.group1
        for (const data of group1) {
          data.fixed = true
        }
        this.form.group1 = group1
      }
    }
  },
};
</script>

<style scoped lang="scss">
.label-text {
  width: 114px;
  font-weight: 500;
  font-size: 14px;
}
</style>
